import { render, staticRenderFns } from "./ActionsColaboradorModal.vue?vue&type=template&id=36c6813c&"
import script from "./ActionsColaboradorModal.vue?vue&type=script&lang=js&"
export * from "./ActionsColaboradorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports